module.exports = __webpack_public_path__ + "img/Tucan_redondo.258de521.svg";